













































































































































































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import {State} from 'vuex-class';
import {Mall, PostCouponsIssuePlansRequest, GetMembersCountRequest} from 'supporter';
import PageTitle from '@/components/common/PageTitle.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import {ncpPopup} from '@/utils/commonUtils';
import {addDay, addMonth} from '@/utils/dateUtils';
import { ExcelBulkRegistrationCallback } from '@/types/promotion';

@Component({
  components: {PageTitle, PeriodDateCalendar, DateCalendar}
})
export default class IssuePlanAddForm extends Vue {
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private theForm: PostCouponsIssuePlansRequest = {
    data: {
      mallNo: 0,
      couponIssueTargetType: 'MEMBER',
      couponIssueTargetMember: {
        couponIssueMemberType: 'MEMBER_NO',
        memberGroupNos: [-1],
        memberGradeNos: [-1],
        memberNos: []
      },
      issueReason: '',
      couponIssueTimeType: 'IMMEDIATELY_ISSUE',
      requestYmdt: '',
      notificationTools: ['SMS', 'EMAIL'],
      useNotification: false,
      notificationRequestYmdt: '',
      periodStartYmdt: '',
      periodEndYmdt: '',
      couponNos: []
    }
  };

  private periodStartYmdtDefaultDateDis: boolean = false;
  private periodEndYmdDefaultDateDis: boolean = true;
  private requestYmdtDefaultDateDis: boolean = false;

  private copyBtnShow: boolean = false;
  private issueEndBtnShow: boolean = false;

  private lastTargetType: string = 'MEMBER';
  private setLastTargetType(lastTargetType: string): void {
    this.lastTargetType = lastTargetType;
  }

  private requestYmdtDefaultDate = addDay(new Date(), 0);
  private periodStartYmdtDefaultDate = addDay(new Date(), 0);
  private periodEndYmdDefaultDate = addMonth(new Date(), 1) + ' 23:59:59';
  private notificationRequestYmdtDefaultDate = addDay(new Date(), 0);
  private notificationRequestYmdtDisabled = true;
  private theIssueStatusType = '';
  private _changeYn = 'N';
  private theIssueCount = 0;
  private theNextMonth = addMonth(new Date(), 1);
  private memberTargetCnt: number = 0;
  private checkAll: boolean = true;
  private couponNo: number = 1;
  private numArr: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  private requestYmdtDefaultDateOption = {
    dateType: 'YmdHm',
    name: 'requestYmdtDefault',
    fromRanges: addDay(new Date(), 0)
  };
  private calendarOption1 = {
    dateType: 'YmdHm',
    name: 'periodYmdtDefault',
    fromRanges: addDay(new Date(), 0),
    endDate: false,
    havePeriodBtn: false
  };
  private periodStartYmdtDefaultDateOption = {
    dateType: 'YmdHm',
    name: 'periodStartYmdtDefault',
    fromRanges: addDay(new Date(), 0)
  };
  private periodEndYmdDefaultDateOption = {
    dateType: 'YmdHm',
    name: 'periodEndYmdDefault',
    fromRanges: addDay(new Date(), 1),
    endDate: true,
    endDatePositiveOrder: true
  };
  private notificationRequestYmdtDefaultDateOption = {
    dateType: 'YmdHm',
    name: 'periodStartYmdtDefault',
    fromRanges: addDay(new Date(), 0)
  };
  @Watch('theForm.data.notificationTools.length', {immediate: false, deep: false})
  length(next: number) {
    this.checkAll = next === 2;// NOTE : kakao 삭제
  }
  private get title() {
    if (this.$route.path.indexOf('modifyForm') !== -1) {
      return this.$t('PROMOTION_ADDFORM_MODIFY_TITLE');
    }
    return this.$t('PROMOTION_ADDFORM_TITLE');
  }
  private theCheckChange(): void {
    if (this.checkAll) {
      this.theForm.data.notificationTools = ['SMS', 'EMAIL'];
    } else {
      this.theForm.data.notificationTools = [];
    }
  }
  private couponNoChange() {
    let oldCount = this.couponData.length;
    let newCount = this.couponNo;
    if (newCount === oldCount) {
      return false;
    }
    if (newCount - oldCount > 0) {
      //add
      let count = newCount - oldCount;
      for (let i = 0; i < count; i++) {
        this.couponData.push({
          couponNo: '',
          issueLimitCnt: '',
          totalIssueCnt: '',
          couponName: '',
          issueStartYmdt: '',
          issueEndYmdt: '',
          issuePeriod: ''
        });
      }
    } else {
      this.couponData.splice(newCount, oldCount);
    }
  }

  private couponNoDelete(index) {
    this.couponData.splice(index, 1);
    this.couponNo = this.couponNo - 1;
  }
  private goBack() {
    this.$router.go(-1);
  }
  private isModify(): boolean {
    return location.href.includes('modifyForm');
  }
  private cancelSub(): void {
    if (this.isModify()) {
      if (this._changeYn === 'Y') {
        if (confirm(this.$t('PROMOTION_ADDFORM_IS_CANCEL2') as string)) {
          this.goList();
        }
      } else {
        this.goList();
      }
    } else if (confirm(this.$t('PROMOTION_ADDFORM_IS_CANCEL') as string)) {
      this.goBack();
    }
  }
  private onChangeInputAndSelect() {
    this._changeYn = 'Y';
  }
  private onChangeTargetType(e: any) {
    const value = $(e.target).val();
    if (e && this.isNotEmptyMember() && this.lastTargetType !== value && !confirm(this.$t('PROMOTION_ADDFORM_CONFIRM_INIT_MEMBER') as any)) {
      return false;
    }
    if (value === 'CONDITION') {
      (this.theForm.data.couponIssueTargetMember as any).memberGradeNos = [-1];
      (this.theForm.data.couponIssueTargetMember as any).memberGroupNos = [-1];
      (this.theForm.data.couponIssueTargetMember as any).memberNos = [];
      $('#paymentTargets').val('');
      this.memberTargetCnt = 0;
      this.theForm.data.couponIssueTimeType = 'PERIOD_ISSUE';

      this.periodEndYmdDefaultDateDis = false;
    }
    this.lastTargetType = value as string;
    return true;
  }
  private onClickTargetTypeMember(e) {
    const value = $(e.target).val();
    if (e) {
      this.theForm.data.couponIssueTimeType = 'IMMEDIATELY_ISSUE';
    }
    this.lastTargetType = value as string;
  }

  private onClickSearchCoupon(e: any) {
    if (this.checkMallNo()) {
      const couponRowIndex = $(e.target).parents('.coupon_row').attr('data-index');
      const mallNo = this.theForm.data.mallNo;
      (window as any).setCouponInfo = this.setCouponInfo;
      const url = `/event/popup/searchCoupon?mallNo=${mallNo}&couponRowIndex=${couponRowIndex}&callback=setCouponInfo&issueType=INSERT`;
      ncpPopup(url, '쿠폰 선택', 1280, 780);
    }
  }
  private checkMallNo() {
    if (this.theForm.data.mallNo === 0) {
      alert(this.$t('PROMOTION_ADDFORM_MALL_IS_EMPTY'));
      $('#mallNo').focus();
      return false;
    }
    return true;
  }
  private couponData: any[] = [
    {
      couponNo: '',
      issueLimitCnt: '',
      totalIssueCnt: '',
      couponName: '',
      issueStartYmdt: '',
      issueEndYmdt: '',
      issuePeriod: ''
    }
  ];
  private setCouponInfo(coupon: any) {
    this.couponData[coupon.couponRowIndex].couponNo = coupon.no;
    this.couponData[coupon.couponRowIndex].issueLimitCnt = coupon.issueLimitCnt;
    this.couponData[coupon.couponRowIndex].totalIssueCnt = coupon.totalIssueCnt;
    this.couponData[coupon.couponRowIndex].couponName = coupon.couponName;
    this.couponData[coupon.couponRowIndex].issueStartYmdt = coupon.issueStartYmdt;
    this.couponData[coupon.couponRowIndex].issueEndYmdt = coupon.issueEndYmdt;
    this.couponData[coupon.couponRowIndex].issuePeriod = `${coupon.issueStartYmdt} ~ ${coupon.issueEndYmdt}` as string;
    (window as any).setCouponInfo = undefined;
  }

  private clearCouponInfo() {
    this.theForm.data.couponNos = [];
    this.couponNo = 1;
    this.couponNoChange();
    this.couponData = [
      {
        couponNo: '',
        issueLimitCnt: '',
        totalIssueCnt: '',
        couponName: '',
        issueStartYmdt: '',
        issueEndYmdt: ''
      }
    ];
  }
  private removeErrorBox(e) {
    $(e.target).parents('.error').removeClass('error');
  }
  private isNotEmptyMember() {
    return (
      this.theForm.data.couponIssueTargetMember.memberNos.length > 0 ||
      this.theForm.data.couponIssueTargetMember.memberGroupNos[0] != -1 ||
      this.theForm.data.couponIssueTargetMember.memberGradeNos[0] != -1
    );
  }
  private couponIssueTargetTypeSelected: string = '';
  private validate() {
    if (!this.checkMallNo()) {
      return false;
    }
    if (this.theForm.data.couponIssueTargetType === 'MEMBER' && !this.isNotEmptyMember()) {
      alert(this.$t('PROMOTION_ADDFORM_TARGETS_IS_EMPTY'));
      return false;
    }
    if (this.theForm.data.couponIssueTimeType === 'IMMEDIATELY_ISSUE' && this.isEmptyMemberTargets()) {
      alert(this.$t('PROMOTION_ADDFORM_MEMBER_COUNT_IS_EMPTY'));
      return false;
    }
    if (this.theForm.data.couponIssueTargetType !== 'MEMBER' && this.couponIssueTargetTypeSelected === '') {
      alert(this.$t('PROMOTION_ADDFORM_TARGETS_IS_EMPTY'));
      return false;
    }

    const now: any = new Date().getTime();
    if (this.theForm.data.couponIssueTimeType === 'SCHEDULED_ISSUE') {
      if (now - Date.parse(this.theForm.data.requestYmdt) > 0) {
        alert(this.$t('PROMOTION_ADDFORM_NOT_VALID_DATE'));
        $('#requestYmdt_wrap').addClass('error');
        return false;
      }
    }
    if (this.theForm.data.couponIssueTimeType === 'PERIOD_ISSUE') {
      if (!this.isModify()) {
        if (now - Date.parse(this.theForm.data.periodStartYmdt) > 0) {
          alert(this.$t('PROMOTION_ADDFORM_NOT_VALID_DATE'));
          $('#start_span_periodYmdtDefault').addClass('error');
          return false;
        }
      }
    }
    if (this.theForm.data.useNotification) {
      if (this.theForm.data.notificationTools.length === 0) {
        alert(this.$t('PROMOTION_ADDFORM_NOT_CHECKED_NOTIFICATION_TOOLS'));
        return false;
      }
      if (this.theForm.data.couponIssueTimeType !== 'PERIOD_ISSUE') {
        if (now - Date.parse(this.theForm.data.notificationRequestYmdt) > 0) {
          alert(this.$t('PROMOTION_ADDFORM_NOTIFICATION_DATE_MUST_FUTURE_THAN_REQUEST_DATE'));
          $('#notificationRequestYmdt_wrap').addClass('error');
          return false;
        }
      }
      if (this.theForm.data.couponIssueTimeType === 'SCHEDULED_ISSUE') {
        if (Date.parse(this.theForm.data.requestYmdt) - Date.parse(this.theForm.data.notificationRequestYmdt) > 0) {
          alert(this.$t('PROMOTION_ADDFORM_NOTIFICATION_DATE_MUST_FUTURE_THAN_REQUEST_DATE'));
          $('#notificationRequestYmdt_wrap').addClass('error');
          return false;
        }
      }
    }
    return true;
  }
  private isEmptyMemberTargets() {
    return this.memberTargetCnt === 0;
  }
  private issue() {
    this.theForm.data.requestYmdt = this.theForm.data.couponIssueTargetType === 'MEMBER' && this.theForm.data.couponIssueTimeType === 'SCHEDULED_ISSUE' ? this.requestYmdtDefaultDate : '';
    this.theForm.data.periodStartYmdt = this.theForm.data.couponIssueTargetType !== 'MEMBER' ? this.periodStartYmdtDefaultDate : '';
    this.theForm.data.periodEndYmdt = this.theForm.data.couponIssueTargetType !== 'MEMBER' ? this.periodEndYmdDefaultDate : '';
    this.theForm.data.notificationRequestYmdt = this.theForm.data.couponIssueTargetType === 'MEMBER' && this.theForm.data.useNotification ? this.notificationRequestYmdtDefaultDate : '';
    this.theForm.data.notificationTools = this.theForm.data.useNotification ? this.theForm.data.notificationTools : null;
    this.theForm.data.useNotification = this.theForm.data.useNotification;
    if (this.validate()) {
      if (this.isModify() && !confirm(this.$t('PROMOTION_ADDFORM_CONFIRM_MODIFY') as any)) {
        return;
      }
      const request: any = {};
      request.mallNo = this.theForm.data.mallNo;
      request.couponIssueTargetType = this.couponIssueTargetTypeSelected;
      const targetType = $('input[name=targetType]:checked').val();
      request.couponIssueTargetType = targetType === 'MEMBER' ? 'MEMBER' : $('#couponIssueTargetType').val();
      if (targetType === 'MEMBER') {
        const couponIssueTargetMember: any = {};
        couponIssueTargetMember.couponIssueMemberType = (this.theForm.data.couponIssueTargetMember as any).couponIssueMemberType;
        couponIssueTargetMember.memberGradeNos = (this.theForm.data.couponIssueTargetMember as any).memberGradeNos;
        couponIssueTargetMember.memberGroupNos = (this.theForm.data.couponIssueTargetMember as any).memberGroupNos;
        couponIssueTargetMember.memberNos = (this.theForm.data.couponIssueTargetMember as any).memberNos;
        request.couponIssueTargetMember = couponIssueTargetMember;
      }
      request.issueReason = $('#issueReason').val();
      const couponIssueTimeType = $('input[name=couponIssueTimeType]:checked').val();
      request.couponIssueTimeType = this.theForm.data.couponIssueTimeType;

      if (couponIssueTimeType === 'SCHEDULED_ISSUE' && this.isEmptyMemberTargets()) {
        alert(this.$t('PROMOTION_ADDFORM_MEMBER_COUNT_IS_EMPTY_WHEN_RESERVATION'));
      }

      if (couponIssueTimeType === 'SCHEDULED_ISSUE') {
        request.requestYmdt = this.theForm.data.requestYmdt;
      } else if (couponIssueTimeType === 'PERIOD_ISSUE') {
        request.periodStartYmdt = this.theForm.data.periodStartYmdt;
        request.periodEndYmdt = this.theForm.data.periodEndYmdt;
      }
      request.useNotification = this.theForm.data.useNotification;
      if (this.theForm.data.useNotification) {
        request.notificationTools = $('input[name=notificationToolTypes]:checked')
          .filter('[value!=ALL]')
          .map((i, ele) => $(ele).val())
          .get();
        if (couponIssueTimeType !== 'PERIOD_ISSUE') {
          request.notificationRequestYmdt = this.theForm.data.notificationRequestYmdt;
        }
      }
      this.couponData.forEach((v) => {
        if (v.couponNo) {
          this.theForm.data.couponNos.push(Number(v.couponNo));
        }
      });

      request.couponNos = [...this.theForm.data.couponNos.filter((v) => v)];
      if (!request.couponNos.length) {
        return alert(this.$t('PROMOTION_ADDFORM_NO_COUPON'));
      }
      if (!this.isModify()) {
        this.$api
          .postCouponsIssuePlans({
            data: request
          })
          .then(() => {
            if (this.theForm.data.couponIssueTimeType === 'SCHEDULED_ISSUE') {
              alert(this.$t('PROMOTION_ADDFORM_SUCCESS_MESSAGE2'));
            } else {
              alert(this.$t('PROMOTION_ADDFORM_SUCCESS_MESSAGE1'));
            }
            this.goList();
          });
      } else {
        this.$api
          .putCouponsIssuePlans({
            pathParams: {
              couponIssuePlanNo: String(this.$route.query.couponIssuePlanNo)
            },
            data: request
          })
          .then(() => {
            alert(this.$t('PROMOTION_ADDFORM_SUCCESS_MESSAGE3'));
            this.goList();
          });
      }
    }
  }

  private goList() {
    this.$router.push({
      path: '/promotion/coupon/issue-plan/list'
    });
  }
  private onClickIssueDetailBtn() {
    ncpPopup(`/promotion/coupon/issue-plan/popup/detail?couponIssuePlanNo=${this.$route.query.couponIssuePlanNo}&mallNo=${this.theForm.data.mallNo}`, '쿠폰 지급현황', 1000, 700);
  }
  private onClickMemberSelectBtn() {
    if (this.checkMallNo()) {
      (window as any).setSelecteGradeAndGroupInfo = this.setSelecteGradeAndGroupInfo;
      let idName: any = 'paymentTargets';
      ncpPopup(`/member/target/popup?mallNo=${$('#mallNo').val()}&callback=setSelecteGradeAndGroupInfo&target=${idName}`, '회원등급/그룹 선택 팝업', 635, 460);
    }
  }
  private setSelecteGradeAndGroupInfo(res: any) {
    this.clearMemberInfo();
    (this.theForm.data.couponIssueTargetMember as any).couponIssueMemberType = 'GRADE_GROUP';
    (this.theForm.data.couponIssueTargetMember as any).memberGradeNos = res.GRADE;
    (this.theForm.data.couponIssueTargetMember as any).memberGroupNos = res.GROUP;
    (this.theForm.data.couponIssueTargetMember as any).memberNos = [];
    let htmlRes = {
      GRADE: ['-1'],
      GROUP: ['-1']
    };
    if (res.GRADE[0] != -1) {
      htmlRes.GRADE = res.GRADE;
    }
    if (res.GROUP[0] != -1) {
      htmlRes.GROUP = res.GROUP;
    }
    $('#paymentTargets').val(JSON.stringify(htmlRes));
    // let obj = {
    //   params: {
    //     mallNo: this.theForm.data.mallNo
    //   }
    // };
    // this.$api.getMemberGroups(obj).then((resp: any) => {
    //   var theCount = 0;
    //   if (res.GROUP && res.GROUP[0] !== '-1') {
    //     res.GROUP.map((item: any) => {
    //       let tempGroup = resp.data.find((temp: any) => temp.no == item);
    //       if (tempGroup) {
    //         theCount += tempGroup.memberCount;
    //       }
    //     });
    //   }

    //   this.$api.getMemberGrades(obj).then((response: any) => {
    //     if (res.GRADE[0] !== '-1') {
    //       res.GRADE.map((item: any) => {
    //         let tempGrade = response.data.find((temp: any) => temp.no == item);
    //         if (tempGrade) {
    //           theCount += tempGrade.memberCount;
    //         }
    //       });
    //     }

    //     $('.targetsCount').text(theCount);
    //     this.memberTargetCnt = theCount;
    //   });
    // });
    let gradeNos = '';
    let groupNos = '';
    if (this.theForm.data.couponIssueTargetMember.memberGradeNos[0] != -1) {
      gradeNos = String(this.theForm.data.couponIssueTargetMember.memberGradeNos);
    }

    if (this.theForm.data.couponIssueTargetMember.memberGroupNos[0] != -1) {
      groupNos = String(this.theForm.data.couponIssueTargetMember.memberGroupNos);
    }
    let request: GetMembersCountRequest = {
      params: {
        mallNo: this.theForm.data.mallNo,
        status: 'ACTIVE',
        gradeNos: gradeNos,
        groupNos: groupNos
      }
    };
    this.$api.getMembersCount(request).then((ret: any) => {
      this.memberTargetCnt = ret.data.count;
      $('.targetsCount').text(ret.data.count);
    });
  }
  private onClickMemberSearchBtn() {
    if (this.checkMallNo()) {
      (window as any).setSearchedMemberInfo = this.setSearchedMemberInfo;
      // sessionStorage.setItem('checkedMembersInfo', `${JSON.stringify(this.theForm.data.couponIssueTargetMember.memberNos)}`);
      ncpPopup(`/member/list/popup/${$('#mallNo').val()}?callback=setSearchedMemberInfo`, '회원 조회 팝업', 1275, 980);
    }
  }

  private handleExcelClick() {
    if (!this.checkMallNo()) {
      return;
    }
    const title = this.$t('PROMOTION_ADDFORM_EXCEL_BATCH_REGISTRATION_PTITLE');
    (window as any).excelMembersCallBack = this.excelCallback;
    const popupUrl = `/popup/excel-batch-registration?mallNo=${this.theForm.data.mallNo}&callback=excelMembersCallBack`;
    ncpPopup(popupUrl, title as string, 900, 450)
  }

  private excelCallback({memberCount, selectedMembers}: ExcelBulkRegistrationCallback): void {
    this.theForm.data.couponIssueTargetMember.couponIssueMemberType = 'MEMBER_NO';
    this.theForm.data.couponIssueTargetMember.memberNos = selectedMembers;
    this.memberTargetCnt = memberCount;
    $('.targetsCount').text(memberCount); //NOTE: 이거 진짜 최악인데 원인파악 시간보다 SaaS에서 변경하는게 더 좋을것같아 우선 사용하겠습니다.
  }

  private setSearchedMemberInfo(res: any) {
    let memberNoBox: string[] = [];
    res.selectedMembers.filter((v) => v).length &&
      res.selectedMembers.map((item) => {
        memberNoBox.push(item.memberNo);
      });
    this.clearGradeAndGroupInfo();
    (this.theForm.data.couponIssueTargetMember as any).couponIssueMemberType = 'MEMBER_NO';
    (this.theForm.data.couponIssueTargetMember as any).memberNos = memberNoBox;
    $('.targetsCount').text(res.memberCount);
    this.memberTargetCnt = res.memberCount;
    $('#recipientsTargetType').val('MEMBER_NO');
    $('#recipients').val(res.selectedMembers);
    (window as any).setSearchedMemberInfo = undefined;
  }
  private setInitSearchedMemberInfo(res: any) {
    let memberNoBox: string[] = [];
    res.selectedMembers.filter((v) => v).length &&
      res.selectedMembers.map((item) => {
        memberNoBox.push(item.memberNo);
      });
    $('.targetsCount').text(res.memberCount);
    this.memberTargetCnt = res.memberCount;
    $('#recipientsTargetType').val('MEMBER_NO');
    $('#recipients').val(res.selectedMembers);
  }
  private onChangeMallNo() {
    this.clearMemberInfo();
    this.clearGradeAndGroupInfo();
    this.clearCouponInfo();
  }
  private clearMemberInfo() {
    (this.theForm.data.couponIssueTargetMember as any).memberNos = [];
    (this.theForm.data.couponIssueTargetMember as any).couponIssueMemberType = '';
    $('.targetsCount').text(0);
    this.memberTargetCnt = 0;
    $('#recipientsTargetType').val('');
    $('#recipients').val('');
  }
  private clearGradeAndGroupInfo() {
    (this.theForm.data.couponIssueTargetMember as any).couponIssueMemberType = '';
    (this.theForm.data.couponIssueTargetMember as any).memberGradeNos = [-1];
    (this.theForm.data.couponIssueTargetMember as any).memberGroupNos = [-1];
    $('#paymentTargets').val('');
    $('.targetsCount').text(0);
    this.memberTargetCnt = 0;
  }
  private onClickCopyBtn() {
    if (confirm(this.$t('PROMOTION_ADDFORM_CONFIRM_COPY') as any)) {
      location.href = `/promotion/coupon/issue-plan/addForm?couponIssuePlanNo=${this.$route.query.couponIssuePlanNo}`;
    }
  }
  private onClickIssueEndBtn() {
    let confirmMessage = '';
    let successMessage = '';
    if (this.theIssueStatusType === 'ISSUE_READY') {
      confirmMessage = 'PROMOTION_ADDFORM_CONFIRM_ISSUE_CANCEL';
      successMessage = 'PROMOTION_ADDFORM_ISSUE_CANCELED';
    } else {
      confirmMessage = 'PROMOTION_ADDFORM_CONFIRM_ISSUE_END';
      successMessage = 'PROMOTION_ADDFORM_ISSUE_END';
    }
    if (confirm(this.$t(confirmMessage) as any)) {
      let obj = {
        pathParams: {
          couponIssuePlanNo: String(this.$route.query.couponIssuePlanNo)
        }
      };
      this.$api.putCouponsIssuePlansTerminate(obj).then(() => {
        alert(this.$t(successMessage));
        this.goList();
      });
    }
  }
  private setDisplay() {
    if (this.$route.query.couponIssuePlanNo) {
      this.renderData();
    }
  }
  private renderData() {
    let obj = {
      pathParams: {
        couponIssuePlanNo: String(this.$route.query.couponIssuePlanNo)
      }
    };
    this.$api.getCouponsIssuePlansCouponIssuePlanNo(obj).then((res: any) => {
      // this.couponName = res.data.coupons[0].name;
      this.setData(res.data);
      if (this.isModify()) {
        this.$nextTick(() => {
          this.setModifyMode();
        });
      }
      this._changeYn = 'N';
    });
  }
  private setData(data: any) {
    const isModify = this.isModify();
    this.theForm.data.mallNo = data.mallNo;
    if (isModify) {
      this.theIssueCount = data.issueCount;
      this.theIssueStatusType = data.issueStatusType;
      if (this.theIssueStatusType === 'ISSUE_END') {
        $('.onlyFuture').removeClass('onlyFuture');
        $('.todayFuture').removeClass('todayFuture');
      } else if (this.theIssueStatusType === 'ISSUE_ING') {
        $('.onlyFuture').removeClass('onlyFuture');
        $('.todayFuture').not('#periodEndYmdt').removeClass('todayFuture');
      }
    }

    // 지급 회원대상
    if (data.target.type === 'MEMBER') {
      this.clickRadio('targetType', 'MEMBER');
      this.setMemberTargets(data.target.member);
      sessionStorage.setItem('checkedMembersInfo', `${JSON.stringify(data.target.member.memberNos)}`);
      this.theForm.data.couponIssueTargetMember.memberNos = data.target.member.memberNos;
    } else {
      this.clickRadio('targetType', 'CONDITION');
      // $('#couponIssueTargetType').val(data.target.type).trigger('change');
      this.couponIssueTargetTypeSelected = data.target.type;
    }

    $('#issueReason').val(data.issueReason);

    // 지급 설정
    // this.clickRadio('couponIssueTimeType', data.time.type);
    this.theForm.data.couponIssueTimeType = data.time.type;
    if (isModify) {
      if (data.time.type === 'SCHEDULED_ISSUE') {
        this.theForm.data.requestYmdt = data.time.requestYmdt;
        // this.requestYmdtDefaultDate = this.getTimePickerVal(data.time.requestYmdt);
        this.requestYmdtDefaultDate = data.time.requestYmdt;
        if (data.issueStatusType === 'ISSUE_READY') {
          this.requestYmdtDefaultDateDis = false;
        } else {
          this.requestYmdtDefaultDateDis = true;
        }
      } else if (data.time.type === 'PERIOD_ISSUE') {
        this.theForm.data.periodEndYmdt = data.time.periodEndYmdt;
        // this.periodEndYmdDefaultDate = this.getTimePickerVal(data.time.periodEndYmdt);
        this.periodEndYmdDefaultDate = data.time.periodEndYmdt;
        this.theForm.data.periodStartYmdt = data.time.periodStartYmdt;
        this.periodStartYmdtDefaultDate = data.time.periodStartYmdt;
        // this.periodStartYmdtDefaultDate = this.getTimePickerVal(data.time.periodStartYmdt);
        if (data.issueStatusType === 'ISSUE_END') {
          this.periodStartYmdtDefaultDateDis = true;
          this.periodEndYmdDefaultDateDis = true;
        } else if (data.issueStatusType === 'ISSUE_ING') {
          this.periodStartYmdtDefaultDateDis = true;
          this.periodEndYmdDefaultDateDis = false;
        } else {
          this.periodStartYmdtDefaultDateDis = false;
          this.periodEndYmdDefaultDateDis = false;
        }
      }
    }
    // 지급알립 설정
    if (!isModify) {
      this.notificationRequestYmdtDisabled = false;
    }
    if (data.usesNotification) {
      this.clickRadio('useNotification', 'true');
      // $('input[name=notificationToolTypes]').attr('checked', false as any);
      // $('input[name=notificationToolTypes]').each((i, ele) => {
      //   if (data.notification.notificationTools.includes($(ele).val())) {
      //     $(ele).trigger('click');
      //   }
      // });

      //NOTE : KAKAO 삭제
      this.theForm.data.notificationTools = data.notification.notificationTools.filter(notification => notification !== 'KAKAO');

      if (isModify && data.notification.notificationRequestYmdt !== null) {
        this.theForm.data.notificationRequestYmdt = data.notification.notificationRequestYmdt;
        // this.notificationRequestYmdtDefaultDate = this.getTimePickerVal(data.notification.notificationRequestYmdt);
        this.notificationRequestYmdtDefaultDate = data.notification.notificationRequestYmdt;
      }
    }

    // 할인쿠폰 설정
    // $('#couponNumber')
    //   .val(data.coupons.length)
    //   .trigger('change');
    this.theForm.data.issueReason = data.issueReason;
    this.couponNo = data.coupons.length;
    this.couponNoChange();
    data.coupons.forEach((coupon: any, index: any) => {
      coupon.couponRowIndex = index;
      coupon.couponName = coupon.name;
      this.$nextTick(() => {
        this.setCouponInfo(coupon);
      });
    });
  }
  private setModifyMode() {
    // 쇼핑몰은 수정 무조건 못해
    $('#mallNo').attr('disabled', 'disabled');
    this.copyBtnShow = true;
    if (this.theIssueStatusType !== 'ISSUE_END') {
      this.issueEndBtnShow = true;
    }
    $('#saveBtn').text($('#modifyBtnMsg').val() as any);
    if (this.theIssueStatusType === 'ISSUE_END') {
      $('#saveBtn').hide();
      this.disableInput();
      this.disableCouponBtn();
      if (this.theIssueCount > 0) {
        $('#issueDetailBtn1').show();
        $('#issueDetailBtn2').show();
      }
      $('#memberSelectBtn').hide();
      $('#memberSearchBtn').hide();
    } else if (this.theIssueStatusType === 'ISSUE_ING') {
      $('#issueEndBtn').text(window.$t('PROMOTION_ADDFORM_ISSUE_OVER'));
      $('#issueEndBtn').show();
      $('#issueDetailBtn2').show();
      this.disableInput([
        'selecdYmd_periodEndYmdDefault',
        'notificationToolTypes_ALL',
        'selecdHms',
        'useNotification',
        'notificationToolTypes',
        'notificationRequestYmdt',
        'notificationRequestYmdt_timepicker'
      ]);
      this.disableCouponBtn();
    } else if (this.theIssueStatusType === 'ISSUE_READY') {
      $('#issueEndBtn').text(window.$t('PROMOTION_ADDFORM_ISSUE_CANCEL'));
      $('#issueEndBtn').show();
      this.notificationRequestYmdtDisabled = false;
    } else {
      this.notificationRequestYmdtDisabled = false;
    }
  }
  private disableInput(excludes?: any) {
    excludes = excludes || [];
    $('[type="text"]')
      .filter((i, ele) => !excludes.includes($(ele).attr('id')))
      .attr('disabled', 'disabled');
    $('select')
      .filter((i, ele) => !excludes.includes($(ele).attr('name')))
      .attr('disabled', 'disabled');
    // $('select')
    //   .filter((i, ele) => !excludes.includes($(ele).attr('name')))
    //   .attr('disabled', 'disabled');
    $('[type="radio"]')
      .filter((i, ele) => !excludes.includes($(ele).attr('name')))
      .attr('disabled', 'disabled');
    $('[type="checkbox"]')
      .filter((i, ele) => !excludes.includes($(ele).attr('name')))
      .attr('disabled', 'disabled');
  }
  private disableCouponBtn() {
    $('.deleteCouponRow').attr('disabled', 'disabled');
    $('.searchCoupon').attr('disabled', 'disabled');
  }
  private clickRadio(name: any, value: any) {
    $(`input[name=${name}][value=${value}]`)
      .attr('checked', true as any)
      .trigger('click');
  }
  private getTimePickerVal(ymdt: any) {
    return ymdt.split(' ')[1].substring(0, 5);
  }
  private setMemberTargets(couponIssueTargetMember: any) {
    if (couponIssueTargetMember.couponIssueMemberType === 'MEMBER_NO') {
      const memberRes: any = {};
      memberRes.memberCount = couponIssueTargetMember.memberNos.length;
      memberRes.selectedMembers = couponIssueTargetMember.memberNos;
      this.setInitSearchedMemberInfo(memberRes);
    } else {
      const paymentTargets = this.getPaymentTargets(couponIssueTargetMember);
      this.setSelecteGradeAndGroupInfo(paymentTargets);
    }
  }
  // 적립금 지급의 타겟을 가져다 써서 어쩔 수 없이 변환
  private getPaymentTargets(couponIssueTargetMember: any) {
    const paymentTargets: any = {};
    if (couponIssueTargetMember.memberGradeNos.length > 0) {
      paymentTargets.GRADE = couponIssueTargetMember.memberGradeNos;
    } else {
      paymentTargets.GRADE = ['-1'];
    }

    if (couponIssueTargetMember.memberGroupNos.length > 0) {
      paymentTargets.GROUP = couponIssueTargetMember.memberGroupNos;
    } else {
      paymentTargets.GROUP = ['-1'];
    }
    return paymentTargets;
  }
  private mounted() {
    if (this.malls.length === 1) {
      this.theForm.data.mallNo = this.malls[0].mallNo;
      this.clearMemberInfo();
      this.clearGradeAndGroupInfo();
      this.clearCouponInfo();
    }
    this.couponNoChange();
    this.setDisplay();
    $('body').on('change', 'input,select', $.proxy(this.onChangeInputAndSelect, this));
    $('body').on('click', '#conditionRadio', $.proxy(this.onChangeTargetType, this));
    $('body').on('click', '#memberRadio', $.proxy(this.onClickTargetTypeMember, this));
    $('body').on('focus', '.error', $.proxy(this.removeErrorBox, this));
  }
  private destroyed() {
    sessionStorage.removeItem('checkedMembersInfo');
  }
}
